import { graphql } from '@teachino/shared-infrastructure';

export const syncItemInfoFromItemTemplateMutation = graphql(`
  mutation syncItemInfoFromItemTemplate($itemId: String!) {
    syncItemWithTemplate(
      itemTemplateSyncInput: { id: $itemId, syncMode: SINGLE }
    ) {
      done
    }
  }
`);
